import { OverlayHeaderMobile } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  OverlayHeaderMobile,
  React
};